import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { useConfig } from 'client/config';

import { FlashMessage, FlashMessageType } from '@pegasus/ui-components/legacy/FlashMessage';
import { Footer } from '@pegasus/ui-footers/components/footer';
import { FeedbackOverlay } from '@pegasus/ui-footers/components/feedback';
import { postLegacyFeedback } from '@pegasus/ui-footers/components/form/helpers';

import { TranslateContext } from '@pegasus/translation/components/TranslateContext';

import { getCustomer } from '../CustomerInfo/redux';
import { addClientFlashMessage } from '../flash-messages/redux/index';
import { useFooterWithPrefetch } from './redux/hooks';
import { Appdomain } from '../../../shared/enums';

export const FooterWrapper = () => {
    const config = useConfig();
    const dispatch = useDispatch();
    const footer = useFooterWithPrefetch(config.locale[config.appdomain as Appdomain]);
    const customer = useSelector(getCustomer);
    const translateContext = useContext(TranslateContext);

    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

    const intl = useIntl();

    return (
        <>
            {customer && (
                <FeedbackOverlay
                    isShown={isFeedbackOpen}
                    closeDialog={() => {
                        setIsFeedbackOpen(false);
                    }}
                    messages={
                        errorMessage && (
                            <FlashMessage
                                type={FlashMessageType.ERROR}
                                disableAnimation
                                onHide={() => setErrorMessage(undefined)}
                            >
                                {errorMessage}
                            </FlashMessage>
                        )
                    }
                    customer={customer}
                    onSubmit={values => {
                        return postLegacyFeedback(
                            values,
                            typeof window !== 'undefined' ? window.CSRF : '',
                        ).then(response => {
                            if (!response.ok) {
                                setErrorMessage(
                                    intl.formatMessage({
                                        id: 'feedbackOverlay.failedSendEmail',
                                    }),
                                );

                                return;
                            }

                            dispatch(
                                addClientFlashMessage({
                                    message: intl.formatMessage({
                                        id: 'feedbackOverlay.successResponse',
                                    }),
                                    type: 'success',
                                }),
                            );

                            setIsFeedbackOpen(false);
                        });
                    }}
                    translations={translateContext.translations}
                />
            )}
            {footer && (
                <Footer
                    footer={footer}
                    onAction={action => {
                        if (action === 'onpage-feedback') {
                            setIsFeedbackOpen(true);
                        }

                        return false;
                    }}
                />
            )}
        </>
    );
};
